import { PluginHook } from '@mdz/mirador/dist/es/src/components/PluginHook'
import FullScreenButton from '@mdz/mirador/dist/es/src/containers/FullScreenButton'
import WindowListButton from '@mdz/mirador/dist/es/src/containers/WindowListButton'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

/**
 * Customized WorkspaceControlPanelButtons that removes WorkspaceMenuButton and WorkspaceOptionsButton, otherwise identical to the upstream WorkspaceControlPanelButtons component.
 *
 * Upstream code was taken from here: https://github.com/ProjectMirador/mirador/blob/v3.3.0/src/components/WorkspaceControlPanelButtons.js
 */
export default class MdzWorkspaceControlPanelButtons extends Component {
  /**
   * render
   *
   * @return {type}  description
   */
  render() {
    const { classes } = this.props
    return (
      <>
        <WindowListButton />
        <FullScreenButton className={classes.ctrlBtn} />
        <PluginHook {...this.props} />
      </>
    )
  }
}

MdzWorkspaceControlPanelButtons.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
}

MdzWorkspaceControlPanelButtons.defaultProps = {
  classes: {},
}
